export const BAR_PREVIEW_TRANSITION_MS = 400;

/** The hard width ceiling for SunnyChat's tablet/desktop corner placement
 * (`MainNavLayout.tsx`, passed explicitly as `maxWidth`) and `SunnyChat`'s own default
 * `maxWidth` when no prop is given. Mobile's inline placement
 * (`CollapsibleRiveBottomNav.tsx`) deliberately does NOT clamp against this - its expanded
 * card is meant to cover the whole nav row edge-to-edge, not stop at some fixed width. */
export const EXPANDED_WIDTH = 344;
export const COLLAPSED_BAR_MIN_WIDTH = 160;
